document.addEventListener("click", (event) => {
  const target = event.target.closest("a");
  if (!target) {
    return;
  }
  const dialogTarget = document.getElementById(target.dataset.dialogOpen);
  const redirectUrl = target.dataset.redirectUrl;
  if (!dialogTarget || !redirectUrl) {
    return;
  }
  let redirectUrlInput = dialogTarget.querySelector("#redirect_url");
  if (!redirectUrlInput) {
    redirectUrlInput = `<input type="hidden" id="redirect_url" name="redirect_url" value="${redirectUrl}">`;
    let form = dialogTarget.querySelector("form");
    if (form) {
      form.insertAdjacentHTML("beforeend", redirectUrlInput);
      redirectUrlInput = dialogTarget.querySelector("#redirect_url");
    }
  }
  if (redirectUrlInput instanceof HTMLElement) {
    redirectUrlInput.value = redirectUrl;
  }
  dialogTarget.querySelectorAll("a").forEach((anchor) => {
    const currentHref = anchor.getAttribute("href");
    if (currentHref) {
      const url = new URL(currentHref, window.location.origin);
      url.searchParams.set("redirect_url", redirectUrl);
      anchor.setAttribute("href", url.toString());
    }
  });
});
